"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const client_library_1 = require("@seneca/client-library");
class InappropriateContentError extends client_library_1.ExtendableError {
    constructor() {
        super('We detected an inappropriate request and could not respond. If this seems wrong, please screenshot this and share with the Seneca team.');
    }
}
exports.default = InappropriateContentError;
//# sourceMappingURL=InappropriateContentError.js.map